import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import moment from "moment-timezone";
import "react-datepicker/dist/react-datepicker.css";

export const Calendar = (props) => {
    const { timeZone: localTZ } = Intl.DateTimeFormat().resolvedOptions();
    const apiTZ = 'utc';
    const [apiTime, setApiTime] = useState(moment.utc());

    useEffect(() => {
        // Update local state from props when they change
        if (props.value) {
            const utcDate = moment(props.value).utc().toISOString(); // Ensure the value is treated as UTC
            setApiTime(utcDate);
        }
    }, [props.value]);

    const handleDateChange = (date) => {
        if (!date) {
            return; // Prevent handling if date is not valid
        }

        const apiTimeFromPickerLocalDate = moment(date)
            .tz(localTZ)
            .tz(apiTZ, true) // Change timezone without changing the local time
            .toISOString(); 
        setApiTime(apiTimeFromPickerLocalDate);

        if (props.onChange) {
            props.onChange(apiTimeFromPickerLocalDate); 
        }
    };

    const filterPassedTime = (time) => {
        const selectedDate = moment(time).tz(apiTZ, true); // Convert selected time to UTC

        if (props.minTime && props.maxTime) {
            const minDate = moment.utc(props.minTime); // Convert minTime to UTC
            const maxDate = moment.utc(props.maxTime); // Convert maxTime to UTC

            // Check if the selected time is within the min and max range
            return selectedDate.isBetween(minDate, maxDate, null, '[]'); // Inclusive check
        }

        return true; // Allow all times if no constraints exist
    };

    // Convert minDate and maxDate props to Date objects and ensure they're valid
    const minDate = props.minDate ? new Date(props.minDate) : undefined;
    const maxDate = props.maxDate ? new Date(props.maxDate) : undefined;

    return (
        <DatePicker
            selected={
                moment(apiTime)
                    .tz(apiTZ)
                    .tz(localTZ, true)
                    .toDate() // Ensure this produces a valid Date object
            }
            onChange={handleDateChange}
            required={props.required}
            disabled={props.readonly}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={1}
            dateFormat="yyyy-MM-dd HH:mm"
            filterTime={filterPassedTime}
            minDate={minDate}
            maxDate={maxDate}
            //minTime={props.minTime ? moment.tz(props.minTime, localTZ).toDate() : undefined}
            //maxTime={props.maxTime ? moment.tz(props.maxTime, localTZ).toDate() : undefined}
        />
    );
};